export const createAudioContext = (deviceId, kind) => {
    if ('audioinput' === kind) {
        return new AudioContext();
    }

    // sinkId in the AudioContext constructor is supported in Chrome/Edge 110+.
    // Some device types (HDMI, Bluetooth, virtual) may throw in Edge even on
    // supported versions — fall back to the default device so TTS still works.
    try {
        return new AudioContext({ sinkId: deviceId });
    } catch (e) {
        console.warn('[AudioContext] sinkId routing failed for device', deviceId, '— falling back to default output.', e);
        return new AudioContext();
    }
}
